import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['groups', 'group', 'groupTitle', 'row', 'groupTemplate', 'cardTemplate', 'help'];

  connect() {
    this.renumber = this.renumber.bind(this);
    this.form = this.element.closest('form');
    this.form?.addEventListener('submit', this.renumber);
    this.toggleEmpty();
  }

  disconnect() {
    this.form?.removeEventListener('submit', this.renumber);
  }

  addGroup() {
    this.groupsTarget.insertAdjacentHTML('beforeend', this.fresh(this.groupTemplateTarget));
    this.renumber();
    this.toggleEmpty();
    this.groupTargets[this.groupTargets.length - 1]?.querySelector('[data-curation-editor-target="groupTitle"]')?.focus();
  }

  addCard(event) {
    const cards = event.currentTarget.closest('[data-curation-editor-target="group"]')
      .querySelector('[data-curation-sortable-cards]');

    cards.insertAdjacentHTML('beforeend', this.fresh(this.cardTemplateTarget));
    this.renumber();
    cards.lastElementChild?.querySelector('.choices, select')?.focus();
  }

  removeRow(event) {
    this.discard(event.currentTarget.closest('[data-curation-editor-target="row"]'));
    this.renumber();
  }

  removeGroup(event) {
    const group = event.currentTarget.closest('[data-curation-editor-target="group"]');

    group.querySelectorAll('[data-curation-editor-target="row"]').forEach((row) => this.discard(row));
    if (group.querySelector('input[data-curation-editor-destroy]')) {
      group.classList.add('hidden');
    } else {
      group.remove();
    }
    this.renumber();
    this.toggleEmpty();
  }

  renumber() {
    let position = 0;

    this.visible(this.groupTargets).forEach((group) => {
      const title = group.querySelector('[data-curation-editor-target="groupTitle"]').value;

      this.visible([...group.querySelectorAll('[data-curation-editor-target="row"]')]).forEach((row) => {
        row.querySelector('input[data-curation-editor-title]').value = title;
        row.querySelector('input[data-curation-editor-position]').value = position;
        position += 1;
      });
    });
  }

  toggleEmpty() {
    const empty = this.visible(this.groupTargets).length === 0;

    [this.groupsTarget, ...this.helpTargets].forEach((element) => element.classList.toggle('hidden', empty));
  }

  discard(row) {
    const destroyField = row?.querySelector('input[data-curation-editor-destroy]');

    if (!row) return;

    if (destroyField) {
      destroyField.value = '1';
      // The `hidden` attribute loses to the row's `display` class.
      row.classList.add('hidden');
    } else {
      row.remove();
    }
  }

  fresh(template) {
    return template.innerHTML.replace(/NEW_CURATION/g, `${Date.now()}${Math.floor(Math.random() * 1000)}`);
  }

  visible(elements) {
    return elements.filter((element) => !element.classList.contains('hidden'));
  }
}
